import React from 'react';
import { saveAs } from 'file-saver';
import FaIcon from '../../FaIcon';
import ErrorMessage from '../../ErrorMessage';

// Per-instance input ids: the old hardcoded id='fileupload' collided when two pickers
// were mounted at once, so a label's htmlFor could open the wrong picker.
let dropzoneIdCounter = 0;

export default class FileUploadField extends React.Component {
  static defaultProps = {
    onChange: () => {},
    acceptedTypes: '*',
    rawFileFieldName: 'RawFile',
    fileTemplateFunction: null,
  };

  constructor(props) {
    super(props);
    this.state = { selectedFileName: '' };
    this.inputId = `fileupload-${++dropzoneIdCounter}`;

    this.fileUploadOnChange = this.fileUploadOnChange.bind(this);
  }

  fileUploadOnChange(e) {
    if (e.target.files.length > 0) {
      this.setState({ selectedFileName: e.target.files[0].name });
      this.props.onChange(e.target.files[0]);
    } else {
      this.setState({ selectedFileName: '' });
      this.props.onChange(null);
    }
  }

  downloadTemplate() {
    this.props
      .fileTemplateFunction()
      .then((response) => {
        if (response && response.binaryContent) {
          const byteCharacters = atob(response.binaryContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          saveAs(new Blob([byteArray]), `${response.name}.${response.type}`);
        }
      })
      .catch((error) => {
        // SetErrorMessage also writes the error to the console.
        ErrorMessage.SetErrorMessage('FUF52', error);
      });
  }

  // "Accepted: png, jpg, …" derived from the accept attribute; omitted for the '*' default.
  renderAcceptedHint() {
    if (!this.props.acceptedTypes || this.props.acceptedTypes === '*') {
      return null;
    }
    const list = this.props.acceptedTypes
      .split(',')
      .map((type) => type.trim().replace(/^\./, ''))
      .filter((type) => type !== '')
      .join(', ');
    return <div className='ds-drop-hint'>Accepted: {list}</div>;
  }

  render() {
    const hasFile = this.state.selectedFileName !== '';
    return (
      <div className='w-100 ds-dropzone-field'>
        <label
          htmlFor={this.inputId}
          className={`ds-dropzone${hasFile ? ' has-file' : ''}`}
        >
          <FaIcon
            iconName={hasFile ? 'fa-regular fa-file-lines' : 'fa-solid fa-cloud-arrow-up'}
            className='ds-drop-icon'
          />
          <span className='ds-drop-text'>{hasFile ? this.state.selectedFileName : 'Click here to select a file'}</span>
        </label>
        <input
          className='ds-drop-input'
          type='file'
          onChange={this.fileUploadOnChange}
          id={this.inputId}
          accept={this.props.acceptedTypes}
        />
        {this.renderAcceptedHint()}
        {this.props.fileTemplateFunction && (
          <a
            href='#'
            onClick={(e) => {
              e.preventDefault();
              this.downloadTemplate();
            }}
            className='link ds-drop-template'
          >
            Download Template
          </a>
        )}
      </div>
    );
  }
}
